import React from 'react'
import { Link } from 'gatsby'
import { MobileNavigation, DesktopNavigation } from './Navigation'
import Logo from '../../images/logo.svg'

export const Header = () => {
  return (
    <header className="text-gray-400 bg-white">
      <div className="container flex items-center justify-between py-6">
        <Link to="/">
          <img
            src={Logo}
            alt="One More Voice Logo"
            role="presentation"
            className="w-20 h-auto sm:w-24"
          />
        </Link>
        <MobileNavigation />
        <DesktopNavigation />
      </div>
    </header>
  )
}
